// extracted by mini-css-extract-plugin
export var closeButton = "_ld-2";
export var closeButtonIcon = "_ld-3";
export var lightboxContent = "_ld-1";
export var lightboxOverlay = "_ld-0";